import { Tooltip, TooltipInteractionEnum } from 'sonata-react-components';

import type React from 'react';

type Props = {
  children: React.ReactElement;
  name: string;
};

/** Shows the full entity name on hover, so truncated names stay readable. */
export function EntityNameTooltip({ children, name }: Readonly<Props>) {
  return (
    <Tooltip
      config={{
        interactions: [TooltipInteractionEnum.hover],
        placement: 'top',
        portal: true,
        strategy: 'fixed',
        text: name
      }}
    >
      {children}
    </Tooltip>
  );
}
